/** Plusstunden-Liste: Filter gelten zusammen, Sortieren lässt sie stehen. */

export function filterPlusHours(rows, { status, teacherId, date, from, to } = {}) {
  return (rows || []).filter((r) => {
    if (status && status !== 'all' && r.status !== status) return false;
    if (teacherId && r.teacher_id !== teacherId) return false;
    const day = String(r.work_date || '').slice(0, 10);
    if (date && day !== date) return false;
    if (from && day < from) return false;
    if (to && day > to) return false;
    return true;
  });
}

const SORT_VALUE = {
  work_date: (r) => String(r.work_date || ''),
  teacher: (r) => String(r.teacher_name || '').toLocaleLowerCase('de'),
  hours: (r) => Number(r.hours) || 0,
  activity: (r) => String(r.activity || '').toLocaleLowerCase('de'),
  status: (r) => String(r.status || ''),
};

export function sortPlusHours(rows, key, dir) {
  const read = SORT_VALUE[key] || SORT_VALUE.work_date;
  const mul = dir === 'asc' ? 1 : -1;
  return [...(rows || [])].sort((a, b) => {
    const va = read(a);
    const vb = read(b);
    if (va < vb) return -1 * mul;
    if (va > vb) return 1 * mul;
    return 0;
  });
}
